<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">ADD CONTACT EMAIL</h3>
      </div>
        <v-form  @submit.prevent="addContact()">
          <v-layout row wrap>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Contact Email"
                  v-model="contact.contact_email"
                  :rules="requiredRules"
                  required
                  type="email"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-btn :depressed="true" block color="primary" type="submit">Add to Notification List</v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
              <thead>
              <tr>
                <td>Created Date</td>
                <td>Email</td>
                <td>Action</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(contact, key) in facilityContacts" :key="key">
                <td>{{formated_date(contact.created_at)}}</td>
                <td>{{contact.contact_email}}</td>
                <td>
                  <v-btn :depressed="true" small color="error" v-if="contact.status === 5" @click="disableContact(contact.public_id)">Disable</v-btn>
                  <v-btn :depressed="true" small color="warning" v-if="contact.status === 7" @click="enableContact(contact.public_id)">Enable</v-btn>
                  <v-btn :depressed="true" small color="error" v-if="contact.status === 7" @click="deleteContact(contact.public_id)">Delete</v-btn>
                </td>
              </tr>
              </tbody>
            </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'facility-contacts',
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      contact: {
        contact_email: '',
        session_id: localStorage.getItem('lkjhgfdsa'),
        facility_id: this.$route.params.facility_id
      }
    }
  },
  methods: {
    disableContact: function (publicId) {
      var data = {
        contact_id: publicId,
        facility_id: this.$route.params.facility_id
      }
      this.$store.dispatch('make_facility_contact_in_active', data)
    },
    enableContact: function (publicId) {
      var data = {
        contact_id: publicId,
        facility_id: this.$route.params.facility_id
      }
    
      this.$store.dispatch('make_facility_contact_active', data)
    },
    addContact: function () {
      // var instance = this
      this.$store.dispatch('post_facility_contact', this.contact)
      // this.contact.contact_email = ''
    },
    deleteContact: function (publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_a_facility_contact', data)
      this.$store.dispatch('get_all_facility_contacts', this.$route.params.facility_id)
    }
  },
  created () {
    this.$store.dispatch('get_all_facility_contacts', this.$route.params.facility_id)
  }
}
</script>

<style scoped>

</style>
